import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import moment from 'moment';
import GET_ELIGIBLE_HEALTH_PLAN from 'client/queries/health/getEligibleHealthPlan';

const getCoveredApplicants = (applicants = []) =>
  applicants.filter(({ type }) => type === 'coverage');

const createQueryApplicants = (person, group) => {
  const coveredApplicants = getCoveredApplicants(group.applicants);
  const relationships = _.keyBy(person.relationships, 'targetPerson.id');

  return coveredApplicants
    .map((applicant) => {
      if (applicant.personId === person.id) {
        return {
          type: 'PRIMARY',
          age: moment().diff(person.dob, 'years'),
          isTobaccoUser: !!person.tobacco,
        };
      }
      const relationship = relationships[applicant.personId];
      if (!relationship) return null;

      const { targetPerson, type } = relationship;
      const { dob, tobacco } = targetPerson;
      // Mapping domestic partner to spouse since marketplace api does
      // not currently handle domestic partners
      const relationshipType =
        type !== 'SPOUSE' && type !== 'DOMESTIC_PARTNER' ? 'DEPENDENT' : 'SPOUSE';

      return {
        type: relationshipType,
        isTobaccoUser: !!tobacco,
        age: moment().diff(dob, 'years'),
      };
    })
    .filter(x => !!x);
};

export const useGetHealthPlan = (person, group) => {
  const client = useApolloClient();
  const [healthPlan, setHealthPlan] = useState(null);

  useEffect(() => {
    const fetchHealthPlan = async () => {
      const { planExternalId, effectiveDate, planVariant } = group.product;
      const { subsidy } = group;
      const address = person.addresses.find(({ addressType }) => addressType === 'HOME');
      const applicants = createQueryApplicants(person, group);

      const subsidyAmount = _.get(subsidy, 'amountEligible', 0);
      const variables = {
        hiosId: planExternalId,
        subsidyAmount,
        planYear: parseInt(moment(effectiveDate).year() || moment().format('YYYY'), 10),
        zipcode: address.zipcode,
        countyFips: address.countyFips,
        applicants,
        csr: planVariant,
      };

      // Only shop for on-exchange plans if a subsidy is provided
      if (subsidyAmount > 0) {
        _.assign(variables, { onExchange: 'TRUE' });
      }

      const { data } = await client.query({
        query: GET_ELIGIBLE_HEALTH_PLAN,
        variables,
        context: {
          clientName: 'marketplace',
        },
      });

      setHealthPlan(data.getEligibleHealthPlan);
    };

    if (person && group) {
      fetchHealthPlan();
    }
  }, [client, person, group]);

  return healthPlan;
};
